export enum FacebookEditActionTypes {
  FACEBOOK_SELECT_ACTION = "FACEBOOK_SELECT_ACTION",
  FACEBOOK_AD_UNSYNC_COMPLETED = "FACEBOOK_AD_UNSYNC_COMPLETED",
  FACEBOOK_AD_UNSYNC_ERRORED = "FACEBOOK_AD_UNSYNC_ERRORED",
  FACEBOOK_AD_UNSYNC_REQUESTED = "FACEBOOK_AD_UNSYNC_REQUESTED",
}
